export default __webpack_public_path__ + "static/media/icone-primeiros-passos.c8ef5345.svg";